export const INITIALIZE_ALL_USAGES = 'moi/usage/INITIALIZE_ALL_USAGES';
export const INITIALIZE_SUBSCRIPTION_USAGE = 'moi/usage/INITIALIZE_SUBSCRIPTION_USAGE';

export const ALL_USAGES_FETCH = 'moi/usage/ALL_USAGES_FETCH';
export const ALL_USAGES_RECEIVE = 'moi/usage/ALL_USAGES_RECEIVE';

export const SUBSCRIPTION_USAGE_FETCH = 'moi/usage/SUBSCRIPTION_USAGE_FETCH';
export const SUBSCRIPTION_USAGE_RECEIVE = 'moi/usage/SUBSCRIPTION_USAGE_RECEIVE';

export const USAGES_RECEIVE_ERROR = 'moi/usage/USAGES_RECEIVE_ERROR';
